import INDUSTRIES from '../content/industries';
import PhotoBanner from './PhotoBanner';
import SectionHeading from './SectionHeading';
import Reveal from './Reveal';

const pad2 = n => String(n).padStart(2, '0');

export default function IndustryGrid() {
  return (
    <PhotoBanner
      id="industries" labelledBy="ind-h" image="/images/industries-bg.jpg" alt="Warehouse operations scene"
      overlay="linear-gradient(180deg, rgba(32,30,29,.55) 0%, rgba(32,30,29,.92) 70%)" className="border-t-2 border-ink"
    >
      <div className="pb-[clamp(48px,6vw,72px)] pt-banner-top">
        <SectionHeading
          id="ind-h" eyebrow="Industries" eyebrowClass="" title="Built for the work people actually do." titleClass="text-banner"
          aside="Six domains where we already know the regulations, the integrations and the edge cases." asideClass="text-neutral-200"
        />
        <ul className="mt-[clamp(48px,6vw,80px)] grid border-l-2 border-t-2 border-rule-light" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))' }}>
          {INDUSTRIES.map((i, k) => (
            <Reveal as="li" key={i.title} className="border-b-2 border-r-2 border-rule-light px-[22px] pb-[26px] pt-[22px] transition-colors duration-200 hover:bg-accent">
              <div className="text-[14px] font-extrabold">{pad2(k + 1)}</div>
              <h3 className="mt-7 text-[clamp(26px,2.6vw,34px)] leading-none tracking-[-0.03em]">{i.title}</h3>
              <p className="mt-2 text-[15px] text-neutral-200">{i.desc}</p>
            </Reveal>
          ))}
        </ul>
      </div>
    </PhotoBanner>
  );
}
